function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.14678 2.34006C8.40638 2.34235 8.66286 2.2834 8.89537 2.16798C9.12787 2.05256 9.32984 1.88393 9.48484 1.67582C9.64146 1.88221 9.84375 2.04957 10.0759 2.1648C10.308 2.28003 10.5637 2.33999 10.8229 2.33999C11.0821 2.33999 11.3378 2.28003 11.5699 2.1648C11.8021 2.04957 12.0044 1.88221 12.161 1.67582C12.316 1.88393 12.5179 2.05256 12.7504 2.16798C12.9829 2.2834 13.2394 2.34235 13.499 2.34006V1.67147C13.2712 1.65815 13.0526 1.57743 12.8708 1.43956C12.6891 1.30169 12.5525 1.11292 12.4784 0.897245C12.4559 0.830843 12.4132 0.773118 12.3563 0.732127C12.2994 0.691135 12.2311 0.668922 12.161 0.668588C12.0909 0.668086 12.0225 0.689786 11.9656 0.730571C11.9087 0.771355 11.8662 0.829124 11.8442 0.895574C11.7703 1.11161 11.6337 1.30076 11.4518 1.43894C11.2699 1.57712 11.051 1.65807 10.8229 1.67147C10.5951 1.65815 10.3765 1.57743 10.1947 1.43956C10.013 1.30169 9.87637 1.11292 9.8023 0.897245C9.7798 0.830843 9.73711 0.773118 9.6802 0.732127C9.62329 0.691135 9.555 0.668922 9.48484 0.668588C9.41458 0.667078 9.34571 0.688386 9.28859 0.729314C9.23147 0.770242 9.18918 0.828581 9.16806 0.895574C9.09413 1.11161 8.95753 1.30076 8.77566 1.43894C8.59378 1.57712 8.37486 1.65807 8.14678 1.67147H7.81227V1.33718C7.81227 0.982535 7.6713 0.642419 7.42036 0.39165C7.16943 0.140881 6.82908 0 6.47421 0C6.11933 0 5.77899 0.140881 5.52806 0.39165C5.27712 0.642419 5.13615 0.982535 5.13615 1.33718V5.102C4.73839 5.37672 4.43529 5.76756 4.26833 6.22104C4.10137 6.67451 4.07869 7.16846 4.20341 7.63531C4.32813 8.10215 4.59414 8.51908 4.96506 8.82905C5.33598 9.13902 5.79368 9.32688 6.27553 9.36693C6.75738 9.40698 7.23984 9.29727 7.65691 9.05279C8.07397 8.80832 8.40525 8.44104 8.60543 8.0012C8.80561 7.56136 8.86491 7.07045 8.7752 6.59564C8.6855 6.12084 8.45118 5.68533 8.1043 5.34871H8.14678C8.40638 5.351 8.66286 5.29204 8.89537 5.17662C9.12787 5.0612 9.32984 4.89258 9.48484 4.68446C9.64146 4.89086 9.84375 5.05822 10.0759 5.17345C10.308 5.28867 10.5637 5.34863 10.8229 5.34863C11.0821 5.34863 11.3378 5.28867 11.5699 5.17345C11.8021 5.05822 12.0044 4.89086 12.161 4.68446C12.316 4.89258 12.5179 5.0612 12.7504 5.17662C12.9829 5.29204 13.2394 5.351 13.499 5.34871V4.68012C13.2712 4.6668 13.0526 4.58607 12.8708 4.44821C12.6891 4.31034 12.5525 4.12156 12.4784 3.90589C12.4559 3.83949 12.4132 3.78177 12.3563 3.74077C12.2994 3.69978 12.2311 3.67757 12.161 3.67724C12.0909 3.67673 12.0225 3.69843 11.9656 3.73922C11.9087 3.78 11.8662 3.83777 11.8442 3.90422C11.7703 4.12026 11.6337 4.30941 11.4518 4.44759C11.2699 4.58577 11.051 4.66671 10.8229 4.68012C10.5951 4.6668 10.3765 4.58607 10.1947 4.44821C10.013 4.31034 9.87637 4.12156 9.8023 3.90589C9.7798 3.83949 9.73711 3.78177 9.6802 3.74077C9.62329 3.69978 9.555 3.67757 9.48484 3.67724C9.41458 3.67573 9.34571 3.69703 9.28859 3.73796C9.23147 3.77889 9.18918 3.83723 9.16806 3.90422C9.09413 4.12026 8.95753 4.30941 8.77566 4.44759C8.59378 4.58577 8.37486 4.66671 8.14678 4.68012H7.81227V2.34006H8.14678ZM5.80518 1.33718C5.80518 1.15986 5.87567 0.989798 6.00113 0.864413C6.1266 0.739029 6.29677 0.668588 6.47421 0.668588C6.65165 0.668588 6.82182 0.739029 6.94728 0.864413C7.07275 0.989798 7.14324 1.15986 7.14324 1.33718V3.34294H5.80518V1.33718ZM6.47421 8.69165C6.10617 8.69174 5.7484 8.57046 5.45638 8.3466C5.16437 8.12275 4.95444 7.80884 4.85917 7.45359C4.7639 7.09833 4.78862 6.72159 4.92949 6.3818C5.07035 6.04202 5.31949 5.75819 5.63826 5.57435L5.80518 5.47741V4.01153H7.14324V5.47774L7.31016 5.57435C7.62892 5.75819 7.87807 6.04202 8.01893 6.3818C8.1598 6.72159 8.18451 7.09833 8.08925 7.45359C7.99398 7.80884 7.78405 8.12275 7.49204 8.3466C7.20002 8.57046 6.84224 8.69174 6.47421 8.69165Z",
  fill: "#4285F4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26 7.8125H27V6.8125H26V7.8125ZM1 7.8125V6.8125H0V7.8125H1ZM1 16.4062H0V17.4062H1V16.4062ZM26 16.4062V17.4062H27V16.4062H26ZM1.34648 6.8125C0.7942 6.8125 0.346484 7.26022 0.346484 7.8125C0.346484 8.36478 0.7942 8.8125 1.34648 8.8125V6.8125ZM25.5652 8.8125C26.1175 8.8125 26.5652 8.36478 26.5652 7.8125C26.5652 7.26022 26.1175 6.8125 25.5652 6.8125V8.8125ZM26 6.8125C24.3025 6.8125 23.1139 7.11769 22.13 7.40853C21.1314 7.70372 20.5031 7.92252 19.7059 7.92252V9.92252C20.8617 9.92252 21.818 9.5863 22.697 9.32649C23.5906 9.06232 24.5725 8.8125 26 8.8125V6.8125ZM19.7059 7.92252C18.89 7.92252 18.0542 7.69062 16.9886 7.40223C15.9681 7.12606 14.7763 6.8125 13.4559 6.8125V8.8125C14.4792 8.8125 15.4358 9.05395 16.4661 9.33278C17.4513 9.5994 18.5685 9.92252 19.7059 9.92252V7.92252ZM13.4559 6.8125C12.1268 6.8125 11.0252 7.1306 10.0575 7.40559C9.07211 7.68561 8.22058 7.92252 7.20586 7.92252V9.92252C8.53488 9.92252 9.63648 9.60442 10.6042 9.32943C11.5896 9.04941 12.4411 8.8125 13.4559 8.8125V6.8125ZM7.20586 7.92252C6.16862 7.92252 5.01576 7.67431 3.9056 7.39726C3.37397 7.26459 2.82286 7.11789 2.35806 7.01126C1.90238 6.90672 1.41692 6.8125 1 6.8125V8.8125C1.16902 8.8125 1.45929 8.85703 1.91086 8.96062C2.35331 9.06212 2.84097 9.19292 3.42135 9.33775C4.53521 9.61572 5.89935 9.92252 7.20586 9.92252V7.92252ZM0 7.8125V16.4062H2V7.8125H0ZM1 17.4062H26V15.4062H1V17.4062ZM27 16.4062V7.8125H25V16.4062H27ZM1.34648 8.8125C1.5092 8.8125 1.77443 8.85482 2.18692 8.95674C2.59519 9.05763 3.03461 9.18641 3.57548 9.33278C4.61042 9.61287 5.89188 9.92252 7.20586 9.92252V7.92252C6.17609 7.92252 5.11379 7.67715 4.09795 7.40223C3.61343 7.27111 3.1007 7.12238 2.66669 7.01514C2.2369 6.90894 1.76971 6.8125 1.34648 6.8125V8.8125ZM19.7059 9.92252C20.881 9.92252 21.7383 9.57495 22.5132 9.31591C23.2799 9.05958 24.145 8.8125 25.5652 8.8125V6.8125C23.8604 6.8125 22.7724 7.12043 21.879 7.4191C20.9937 7.71507 20.4838 7.92252 19.7059 7.92252V9.92252Z",
  fill: "#4285F4"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 6.46777,
  cy: 11.7187,
  r: 0.78125,
  fill: "#4285F4"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 10.377,
  cy: 13.2813,
  r: 0.78125,
  fill: "#4285F4"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.7202,
  cy: 11.7187,
  r: 0.78125,
  fill: "#4285F4"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.2822,
  cy: 14.8438,
  r: 0.78125,
  fill: "#4285F4"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.8442,
  cy: 10.9375,
  r: 0.78125,
  fill: "#4285F4"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 17.4062,
  cy: 14.0625,
  r: 0.78125,
  fill: "#4285F4"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 19.7495,
  cy: 12.5,
  r: 0.78125,
  fill: "#4285F4"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 23.6548,
  cy: 10.9375,
  r: 0.78125,
  fill: "#4285F4"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 22.0928,
  cy: 13.2813,
  r: 0.78125,
  fill: "#4285F4"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 7.24854,
  cy: 14.0625,
  r: 0.78125,
  fill: "#4285F4"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 3.34326,
  cy: 10.9375,
  r: 0.78125,
  fill: "#4285F4"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 4.12451,
  cy: 13.2813,
  r: 0.78125,
  fill: "#4285F4"
});

function SvgDoMan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoMan);
export default __webpack_public_path__ + "static/media/DoMan.06e5a087.svg";
export { ForwardRef as ReactComponent };